import {
  receiveSynonyms,
  receiveMeanings,
  updateSynonyms,
  updatedMeanings,
} from '../actions/ApiAction';
import 'whatwg-fetch';

import { MogamboRequest, authenticate, captureException } from './index';
import { BASE_URL } from '../const';

export const getSynonyms = sentence => {
  const url = `${BASE_URL}cluster/read_variants?text=${sentence}`;
  const request = MogamboRequest(url, 'GET');
  fetch(request)
    .then(response => {
      const contentType = response.headers.get('content-type');
      if (contentType && contentType.indexOf('application/json') !== -1) {
        return response.json().then(json => {
          authenticate(json);
          receiveSynonyms(json);
        });
      }
      throw new Error('API request failed!');
    })
    .catch(captureException);
};

export const getMeanings = (word, callback) => {
  const url = `${BASE_URL}cluster/get_synonyms?text=${word}`;
  const request = MogamboRequest(url, 'GET');
  fetch(request)
    .then(response => {
      const contentType = response.headers.get('content-type');
      if (contentType && contentType.indexOf('application/json') !== -1) {
        return response.json().then(json => {
          authenticate(json);
          receiveMeanings(json, callback);
        });
      }
      throw new Error('API request failed!');
    })
    .catch(captureException);
};

export const setMeanings = updatedClusters => {
  const url = `${BASE_URL}cluster/update_variants/v2/`;
  const request = MogamboRequest(url, 'POST', updatedClusters);
  return fetch(request)
    .then(response => {
      const contentType = response.headers.get('content-type');
      if (contentType && contentType.indexOf('application/json') !== -1) {
        return response.json().then(json => {
          authenticate(json);
          updatedMeanings();
        });
      }
      throw new Error('Synonyms API request failed!');
    })
    .catch(captureException);
};
